import { Controller } from "@hotwired/stimulus"

// Toggles decay/develop labels and help text based on polarity selection
export default class extends Controller {
  static targets = [
    "legend", "description", "floorHelp", "ceilingHelp",
    "floorField", "ceilingField", "floorWrap", "ceilingWrap"
  ]

  connect() {
    this.update()
  }

  update() {
    const isInverse = this.element.querySelector('input[name*="polarity"][value="inverse"]')?.checked

    if (this.hasLegendTarget) {
      this.legendTarget.textContent = isInverse ? "Develop" : "Decay"
    }
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.textContent = isInverse
        ? "Automatically increase this liability over time (e.g., Heat builds up)."
        : "Automatically decrease this asset over time (e.g., Food spoils)."
    }
    if (this.hasFloorHelpTarget) {
      this.floorHelpTarget.textContent = isInverse
        ? "Not used for liabilities (develops upward)."
        : "Minimum value decay can reach. Default: 1."
    }
    if (this.hasCeilingHelpTarget) {
      this.ceilingHelpTarget.textContent = isInverse
        ? "Maximum value develop can reach. Defaults to scale max."
        : "Not used for assets (decays downward)."
    }

    if (this.hasFloorFieldTarget) {
      this.floorFieldTarget.disabled = !!isInverse
    }
    if (this.hasFloorWrapTarget) {
      this.floorWrapTarget.style.opacity = isInverse ? "0.4" : "1"
    }

    if (this.hasCeilingFieldTarget) {
      this.ceilingFieldTarget.disabled = !isInverse
    }
    if (this.hasCeilingWrapTarget) {
      this.ceilingWrapTarget.style.opacity = !isInverse ? "0.4" : "1"
    }
  }
}
